import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { Models } from '../../models/global.models';
import { PreferredTimeContactLeadStore } from './preferred-time-contact-lead.store';

@Injectable({ providedIn: 'root' })
export class PreferredTimeContactLeadQuery extends Query<Models.PreferredTimeContactLeadForm> {
  protected store: PreferredTimeContactLeadStore;

  dirtyCheck = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(PreferredTimeContactLeadStore);

    super(store);

    this.store = store;
  }
}
